import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { formatBytes } from "../../helpers/formatSize";
import "./styles.css"
import { T } from "../../traks";
import { RenderIf } from "../../helpers/RenderIf";

const FileList = ({ files, removeFile }) => {
	return (
		<div className="d-flex flex-column">
			{files.map((file, index) => (
				<div className="my-3 d-flex flex-row justify-content-between border_radius_6px py-3 px-2 primary-border-thick" key={index + "file-item"}>
					<div className="d-flex flex-row" style={{ flex: 2 }}>
						<div className="align-items-baseline" style={{ flex: 1, alignSelf: "center" }}>
							{file.name}
						</div>
						<div className="text-end" style={{ flex: 1, alignSelf: "center" }}>
							{formatBytes(file.size)}
						</div>
					</div>
					<div className="d-flex justify-content-end" style={{ flex: 1 }}>
						<div className="btn red_avatar avatar text-end" onClick={() => removeFile(file.id)}>
							<img src="https://static.sibilus.eu/gfx/bin-icon-0.svg" alt="bin-icon" style={{width: "1rem"}}/>
						</div>
					</div>
				</div>
			))
			}
		</div >
	);
};


const UploadButton = ({ uploadFiles, files, multiple }) => {
	if (!multiple) {
		return (
			<button
				onClick={() => uploadFiles(files)}
				className="btn btn_green w-100 fw_600"
			>
				<T>Upload file</T>
			</button>
		)
	}
	return (
		<button
			onClick={() => uploadFiles(files)}
			className="btn btn_green w-100 fw_600"
		>
			<T>Upload</T>
			<span>
				{files.length > 0 ? " " + files.length : ""}
			</span>
			<T> files</T>
		</button>
	)
}

const RejectedFileList = ({ files, removeFile }) => {
	return (
		<RenderIf condition={files.length > 0} >
			<div className="d-flex flex-column mb-5">
				{files.map((file, index) => (
					<>
						<div className="mt-3 d-flex flex-row justify-content-between border_radius_6px py-3 px-2 red-border-thick" key={index + "file-item"}>
							<div className="d-flex flex-row" style={{ flex: 2 }}>
								<div className="align-items-baseline" style={{ flex: 1, alignSelf: "center" }}>
									{file.name}
								</div>
								<div className="text-end" style={{ flex: 1, alignSelf: "center" }}>
									{formatBytes(file.size)}
								</div>
							</div>
							<div className="text-end" style={{ flex: 1 }}>
								<div className="cursor_pointer" onClick={() => removeFile(file.id)}>
									<img src="https://static.sibilus.eu/gfx/bin-icon-0.svg" className="sibilus_border p-2 rounded-5 bg_red" alt="bin-icon" style={{width: "24px"}} />
								</div>
							</div>
						</div>
						<div className="txt_red">This document type is not supported. Please remove it and upload another.</div>
					</>
				))}
			</div >
		</RenderIf>
	);
};

const getAcceptedFiles = (logo = false) => {
	if (logo) {
		return {
			"image/jpeg": [".jpg", ".jpeg"],
			"image/png": [".png"],
			"image/svg+xml": [".svg"],
			"image/webp": [".webp"]
		}
	} else {
		return {
			"image/webp": [".webp"],
			"image/svg+xml": [".svg"],
			"application/msword": [".doc"],
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
			"image/jpeg": [".jpg", ".jpeg"],
			"image/png": [".png"],
			"application/pdf": [".pdf"],
			"text/plain": [".txt"],
			"audio/wav": [".wav"],
			"audio/mpeg": [".mp3"],
			"video/mp4": [".mp4"]
		}
	}
}


const Dropzone = ({ onDrop, multiple, files }) => {
	const acceptedFiles = getAcceptedFiles(multiple === true)
	const { getRootProps, getInputProps, isDragActive } =
		useDropzone({
			accept: acceptedFiles,
			onDrop,
			multiple,
			disabled: !multiple && files.length > 0
		});

	return (
		<div className="my-3 dashed-border py-5 mx-auto dropzone border_radius_10px cursor_pointer">
			<div {...getRootProps()}>
				<input className="input-zone" {...getInputProps()} />
				<div className="text-center ">
					{isDragActive ? (<>
						<img src="https://static.sibilus.eu/gfx/dropzone-icon-0.svg" alt="dropzone" />
						<div className="dropzone-content fw_500 mt-3">
							<T>Release to drop the files here</T>
						</div>
					</>) : (<>
						<img src="https://static.sibilus.eu/gfx/dropzone-icon-0.svg" alt="dropzone" />
						<div className="b mt-3">
							<T>Drag & drop files or </T><span className="border-bottom primary-border border-3 fw_600 cursor_pointer"><T>Browse</T></span>
						</div>
						<div className="mt-3 mx-3">
							<RenderIf condition={multiple}>
								<T>Supported formates: </T> SVG, WEBP, JPEG, JPG, PNG, MP3, MP4, PDF, TXT, DOC, DOCX
							</RenderIf>
							<RenderIf condition={!multiple}>
								<T>Supported formates: </T> SVG, WEBP, JPEG, JPG, PNG
							</RenderIf>
						</div>
					</>)}
				</div>
			</div>
		</div>
	);
}


const DropLoad = ({ files, setFiles, uploadFiles = null, multiple = true }) => {
	const [rejectedFiles, setRejectedFiles] = useState([])

	const removeFile = (fileId) => {
		setFiles(files.filter(file => file.id !== fileId))
	}

	const removeRejectedFile = (fileId) => {
		setRejectedFiles(rejectedFiles.filter(file => file.id !== fileId))
	}

	const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
		acceptedFiles.map((file) => {
			const fileId = (new Date()).valueOf();
			const newName = fileId.toString()
			const renamedFile = new File([file], newName)
			const fileItem = {
				id: fileId,
				name: file.name,
				type: file.type,
				file: renamedFile,
				size: file.size
			}
			setFiles((prevVal) => [...prevVal, fileItem])
			return file;
		});

		rejectedFiles.map(file => {
			console.log(file)
			const fileId = (new Date()).valueOf();
			const fileItem = {
				id: fileId,
				name: file.file.name,
				type: file.file.type,
				size: file.file.size
			}
			setRejectedFiles((prevVal) => ([...prevVal, fileItem]))
			return file
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<div>
			<Dropzone
				files={files}
				onDrop={onDrop}
				multiple={multiple}
			/>
			<RejectedFileList
				files={rejectedFiles}
				removeFile={removeRejectedFile}
			/>
			<FileList
				files={files}
				removeFile={removeFile}
			/>
			<RenderIf condition={uploadFiles && files.length > 0}>
				<UploadButton
					files={files}
					uploadFiles={uploadFiles}
					multiple={multiple}
				/>
			</RenderIf>
		</div>
	);
}
export default DropLoad;
